import setCookie from '../helpers/set-cookie';
import getCookie from '../helpers/get-cookie';
import deleteCookie from '../helpers/delete-cookie';

type StorageType = 'session' | 'local' | 'cookie';

export default class Storage {
    private storageType: StorageType;
    private isSessionStorageAvailable: boolean;
    private isLocalStorageAvailable: boolean;
    private prefix: string = 'ccmn.';
    private testKey: string = 'test';

    constructor(storageName: string, storageType: StorageType = 'session') {
        this.prefix = `${this.prefix}${storageName}.`;
        this.storageType = storageType;
        this.isSessionStorageAvailable = this.storageType === 'session' && this.sessionStorageAvailablility();
        this.isLocalStorageAvailable = this.storageType === 'local' && this.localStorageAvailability();
    }

    set(key: string, value: any): void | string {
        const storageName = `${this.prefix}${key}`;
        const storageValue: string = JSON.stringify(value);

        if (this.isSessionStorageAvailable) {
            try {
                return sessionStorage.setItem(storageName, storageValue);
            } catch (e) {
                console.error('sessionStorage not available.');
            }
        }

        if (this.isLocalStorageAvailable) {
            try {
                return localStorage.setItem(storageName, storageValue);
            } catch (e) {
                console.error('localStorage not available.');
            }
        }

        return setCookie(storageName, storageValue);
    }

    get(key: string): any {
        const storageName = `${this.prefix}${key}`;
        let storageValue: any;

        if (this.isSessionStorageAvailable) {
            storageValue = sessionStorage.getItem(storageName);
        } else if (this.isLocalStorageAvailable) {
            storageValue = localStorage.getItem(storageName);
        } else {
            storageValue = getCookie(storageName);
        }

        storageValue = JSON.parse(storageValue);

        return storageValue;
    }

    delete(key: string): void {
        const storageName = `${this.prefix}${key}`;

        if (this.isSessionStorageAvailable) {
            return sessionStorage.removeItem(storageName);
        }

        if (this.isLocalStorageAvailable) {
            return localStorage.removeItem(storageName);
        }

        return deleteCookie(storageName);
    }

    localStorageAvailability() {
        try {
            localStorage.setItem(this.testKey, this.testKey);
            localStorage.removeItem(this.testKey);
            return true;
        } catch (e) {
            return false;
        }
    }

    sessionStorageAvailablility() {
        try {
            sessionStorage.setItem(this.testKey, this.testKey);
            sessionStorage.removeItem(this.testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
}
